import r2wc from '@r2wc/react-to-web-component';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import DepartureListMapper from 'src/components/DeparturesList/DepartureListMapper';
import { AuthProvider } from 'src/providers/AuthProvider/AuthProvider';
import { FeatureFlagsProvider } from 'src/providers/FeatureFlagsProvider/FeatureFlagsProvider';
import LocaleAndThemeProvider from 'src/providers/LocaleAndThemeProvider/LocaleAndThemeProvider';
import QueryProvider from 'src/providers/QueryProvider';
import SelectedDateRangesProvider from 'src/providers/SelectedDateRangesProvider';

const DeparturesListWrapper: React.FC<{ tripCode: string }> = (props) => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <QueryProvider>
          <LocaleAndThemeProvider>
            <FeatureFlagsProvider>
              <SelectedDateRangesProvider>
                <DepartureListMapper {...props} />
              </SelectedDateRangesProvider>
            </FeatureFlagsProvider>
          </LocaleAndThemeProvider>
        </QueryProvider>
      </BrowserRouter>
    </AuthProvider>
  );
};
const DeparturesListComponent = r2wc(DeparturesListWrapper, {
  props: {
    tripCode: 'string',
  },
});

export default DeparturesListComponent;
